/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityServiceFilter } from './FacilityServiceFilter';
import {
    FacilityServiceFilterFromJSON,
    FacilityServiceFilterFromJSONTyped,
    FacilityServiceFilterToJSON,
    FacilityServiceFilterToJSONTyped,
} from './FacilityServiceFilter';
import type { NpiResponseEnumerationType } from './NpiResponseEnumerationType';
import {
    NpiResponseEnumerationTypeFromJSON,
    NpiResponseEnumerationTypeFromJSONTyped,
    NpiResponseEnumerationTypeToJSON,
    NpiResponseEnumerationTypeToJSONTyped,
} from './NpiResponseEnumerationType';

/**
 * 
 * @export
 * @interface ValidatePalNpiRequest
 */
export interface ValidatePalNpiRequest {
    /**
     * 
     */
    npi: string;
    /**
     * 
     */
    submission_id?: string;
    /**
     * 
     */
    npi_type?: NpiResponseEnumerationType;
    /**
     * 
     */
    service_filter?: FacilityServiceFilter;
}



/**
 * Check if a given object implements the ValidatePalNpiRequest interface.
 */
export function instanceOfValidatePalNpiRequest(value: object): value is ValidatePalNpiRequest {
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function ValidatePalNpiRequestFromJSON(json: any): ValidatePalNpiRequest {
    return ValidatePalNpiRequestFromJSONTyped(json, false);
}

export function ValidatePalNpiRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpiRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'npi': json['npi'],
        'submission_id': json['submission_id'] == null ? undefined : json['submission_id'],
        'npi_type': json['npi_type'] == null ? undefined : NpiResponseEnumerationTypeFromJSON(json['npi_type']),
        'service_filter': json['service_filter'] == null ? undefined : FacilityServiceFilterFromJSON(json['service_filter']),
    };
}

export function ValidatePalNpiRequestToJSON(json: any): ValidatePalNpiRequest {
    return ValidatePalNpiRequestToJSONTyped(json, false);
}

export function ValidatePalNpiRequestToJSONTyped(value?: ValidatePalNpiRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'npi': value['npi'],
        'submission_id': value['submission_id'],
        'npi_type': NpiResponseEnumerationTypeToJSON(value['npi_type']),
        'service_filter': FacilityServiceFilterToJSON(value['service_filter']),
    };
}

